/**
 *
 * @param {Number} score
 * @returns {String}
 */
export const getColorForScore = (score) => {
  let _score = score;
  if (_score <= 1) {
    _score = _score * 100;
  }
  if (_score < 50) {
    return "red";
  } else if (_score < 90) {
    return "orange";
  } else {
    return "green";
  }
};
